










































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import ICountUp from 'vue-countup-v2';
import '@/styles/Home.scss';
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Login from '../components/Login.vue';

declare var amp: any;

@Component({
  components: {
    ICountUp,
    login: Login,
    swiper,
    swiperSlide,
  }
})

export default class Home extends Vue {
  private player: any;
  private source = "//elvideoservices-aase.streaming.media.azure.net/ec14b33a-862c-4c00-9a04-84e0e6c90e59/chem1ch1lect1-new.ism/manifest";
  private isHadaf = false;

  private blogs:any = [{heading: 'Overcoming Fears of Youth', 
  excerpt: 'I could remember childhood days specifically school and college days when our biggest fears...', 
  fullblog: 'I could remember childhood days specifically school and college days when our biggest fears were that whether we will be able to perform in exams or not? What will be the result? What if we will fail? This anxiety could lead a child to some serious depression. Only well-groomed confidence could prevent this situation. The confidence which appears only if our motivation to learn is strong enough and the teacher is supporting well in our learning process, only then one can beat depression. In our college days, we used to get extra tuitions in the evening other than our regular college classes and the irony was that sometimes we were not in the mood to study, sometimes teacher was not in the mood to teach and sometimes it was a holiday Voila!, well rest in peace our motivation to learn. But not anymore, thanks to E-Learning by PGC through which you can explore a huge database of e-learning tools in the form of MCQs, Past Papers from last 6 years and hundreds of recorded lectures on PGC E-Learning Application which are available 24/7.  Everything is accessible on a single tap on the smartphone screen. All video lectures are of good quality, prepared on purpose and without any distraction. After the completion of a lecture, a student can also attempt practice questions. Some people say that being independent gives you confidence, which is the opposite of depending on someone’s mood as I mentioned earlier. E-Learning by PGC could make students independent while studying, give them the confidence to perform better in exams and overcome their fears in all situations. We should always appreciate new developments in technology, though it has pros and cons at the same time but if the purpose is to educate a child without any distraction then its positive for everyone. I believe if we try to divert our children’s attention towards the E-Learning portals like PGC instead of keeping them entertained through funny videos on YouTube, we can change the way of learning and can make students independent in all situations.', 
  author: 'Safia Junaid'},
  {heading: 'Breaking Barriers in Education Sector of Pakistan', 
  excerpt: 'Last night I was scrolling through the Google Play Store for an important app and saw PGC App...', 
  fullblog: 'Last night I was scrolling through the Google Play Store for an important app and saw PGC App there. Despite my busy schedule, curiosity hit my brain that what a higher education institute could provide in an app? Maybe some java based free educational games or just an opportunity to show the presence of a brand name on Play Store. But to my surprise it was neither baby shark do do do do gamepad nor the branding gimmick. Actually, it was, in reality, a huge database of e-learning tools in the form of MCQs, Past Papers from last 6 years and hundreds of recorded lectures with a well-aimed purpose. The lectures are of great quality which could use a reasonable amount of internet data. Lectures cover a sufficient range of subjects from the classes of Intermediate level in accordance with all educational boards of Punjab. A free user can see a limited number of videos but the full access is available to the enrolled students of Punjab College and paid subscribers. All videos consist of a great deal of video content and graphical representation. After the completion of a lecture, a student can also attempt practice questions. In the past KHAN Academy, E-Learn Punjab and Sabaq Foundation tried to create this sort of product but KHAN Academy was not aiming specifically for Pakistan, Sabaq Foundation online videos were mostly related to elementary level and E-Learn Punjab was mostly using its page to refer relevant videos and content but nothing is more relevant to the college level like PGC e-learning database. The biggest challenge in Pakistan is that youngsters living in rural areas can study till matriculation but for college, they have to travel to the nearest available college which still requires a huge amount of travel and time to time mobilization. Thanks to the cellular networks of Pakistan which are now available in all remote areas of Pakistan except few, can make it possible for the intermediate students to learn through PGC app using high-speed internet. As I have been associated with the education sector since a long time, I can confidently say that these tools are very much affordable and could be a major game changer in the education sector and e-learning industry of Pakistan.', 
  author: 'Haider Jamshed'},
  {heading: 'Providing Standardized Education', 
  excerpt: 'Life is a lesson and we learn throughout our life from Montessori to Ph.D. with a common source in the form of dozens of teachers...', 
  fullblog: 'Life is a lesson and we learn throughout our life from Montessori to Ph.D. with a common source in the form of dozens of teachers, teaching and motivating us continuously. Some were good and some were bad. Bad doesn’t mean that they were behaving badly or inappropriately but it means that they were good or bad at teaching us, making it easy or difficult for us to learn the concepts. I could remember a teacher during my school who had great knowledge of mathematics but wasn’t able to make us understand a single equation, contrary to that there was another teacher whose qualification was not very high but he was great at teaching us and making us understand a concept by the earliest. I wish I could get the opportunity to learn from all good teachers so that I could get maximum results and knowledge from my studies. Same is the target Punjab Group of Colleges is trying to achieve by using their best teachers and recording well-planned lectures to provide standardized education at the college level through PGC E-Learning Application. The app contains a huge database of e-learning tools in the form of MCQs, Past Papers from last 6 years and hundreds of recorded lectures on PGC E-Learning Application which are available 24/7. Everything is accessible on a single tap on the smartphone screen. All video lectures are of good quality, prepared on purpose and without any distraction. After the completion of a lecture, a student can also attempt practice questions. In the 18th century, standardization was adopted the first time in production by the large scale industrialists to get maximum output while producing at economies of scale and then later on it was part of every consumer products and services industry. Same could be achieved by removing bad teachers from our system and giving our children the best so that they could perform better. Recorded lectures by PGC provide a significant level of accuracy in education and the beauty is that millions of students could benefit from a single video. With the help of technology different institutes of Pakistan could develop more reliable sources of education.', 
  author: 'Uzair Ali'}];

  private blog:any = this.blogs[0];

  swiperOption = {
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      clickable: true,
    },
    keyboard: {
    enabled: true,
    }
  };

  swiperOptionVideo = {
    slidesPerView: 3,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
      clickable: true
    },
    keyboard: {
    enabled: true,
    },
    breakpoints: {
    // when window width is <= 640px
    640: {
      slidesPerView: 1,
    },
    1000: {
      slidesPerView: 2,
    }
    
  }
  };

   options = {
    useEasing: true,
    useGrouping: true,
    separator: ',',
    decimal: '.',
    prefix: '',
    suffix: ''
  }

  changeBlog(blog){
    this.blog = blog;
  }

  handleHide(evt) {
  }

  playVideo(){
    const video = document.getElementById('video1');
    
    if (video){
      (video as any).play();
    }
  }

  mounted(){
    const navbar = document.getElementById('navbar');
    const footer = document.getElementById('footer');

    let origin = window.location.origin;
    if (origin.toLowerCase().indexOf('hadaf') > -1)
      this.isHadaf = true;

    this.$root.$on('bv::modal::hide', (bvEvent) => {
      const iframe = bvEvent.target.getElementsByTagName('iframe')[0];
      if (iframe){
        let src = bvEvent.target.getElementsByTagName('iframe')[0].src;
        iframe.src = src;
      }
    });

    if (navbar !== null){
      navbar.classList.add("home");
    }

    if (footer !==null){
      footer.classList.add("home");
    }

    const rand = Math.random();
    if (rand>=0.5){
      const hero = document.getElementById('hero');

      if (hero){
        hero.classList.add('hero-image-2')
      }
    }
  }

  handleScroll(evt: any, el: any) {
    if (window.scrollY + window.innerHeight > el.getBoundingClientRect().top) {
      (this.$refs.stats1 as any).init();
      (this.$refs.stats2 as any).init();
      (this.$refs.stats3 as any).init();
      (this.$refs.stats4 as any).init();
      return true;
    }
  }
}
